module.exports = __webpack_public_path__ + "img/03.37f7d1eb.svg";